import '@babel/polyfill';
import { createHooks } from '@wordpress/hooks';
import Tippy from 'tippy.js';
import Panzoom from '@panzoom/panzoom';
import Swiper, { Pagination, Navigation } from 'swiper';
import Favorites from './favorites';
import './jquery-functions';
import Helper from './helper';
import FloorSelector from './floor-selector';

window.wphooks = createHooks();

/**
 * @global settings Settings passed by WordPress
 */
class Areas {
  /**
   * Set properties
   */
  constructor() {
    this.popups = [];
    this.lotSelector = document.querySelector('.lot-selector');
    this.areaSelector = $('.lot-selector-area');
    this.popupSelector = $('[data-lot-popup]');
    this.filters = $('.lot-selector-filter');
    this.filterables = this.lotSelector.querySelectorAll('.lot-selector-filterable');
    this.filterForm = $('.lot-selector-filter-form');
    this.settings = Helper.filterObjectValues(settings);
    this.floorSelector = new FloorSelector(this.lotSelector);
    this.floorCarousel = null;
  }

  /**
   * Initialize all needed actions
   */
  init() {
    Areas.setPolyfills();
    this.setPopups();
    Areas.setPointClick();
    Areas.registrationTabs();
    this.setPanzoom();

    /**
     * Trigger form submit on filter
     * 
     * @listens change
     */
    this.filters.on('change', (e) => {
      $(e.currentTarget).parents('form').trigger('submit');
    });

    /**
     * Retrieve data on initialisation
     */
    this.getFilters();

    /**
     * Handle filter form submission
     * 
     * @listens submit
     */
    this.filterForm.on('submit', (e) => {
      e.preventDefault();

      this.getUnits(e);
      this.getFilters(e);
    });


    /**
     * Highlight unit on map
     */
    this.lotSelector.querySelectorAll('.go-to-unit').forEach((highlightButton) => {
      highlightButton.addEventListener('click', e => this.handleHighlightButtonClick(e));
    });

    /**
     * Highlight unit in overview
     */
    this.lotSelector.querySelectorAll('.lot-selector-area').forEach((area) => {
      area.addEventListener('click', e => this.handleHighlightAreaClick(e));
    });

    /**
     * Open registration pop-up
     * 
     * @listens click
     */
    $(document).on('click', '[data-popup-target]', (e) => {
      if ($(window).width() < 768 && $(e.currentTarget).hasClass('lot-item')) {
        return;
      }

      e.preventDefault();
      const popup = $($(e.currentTarget).data('popup-target'));
      Areas.togglePopup(popup);
    });

    /**
     * Close popup when Esc is pressed
     */
    $(document).on('keyup', (e) => {
      if (e.key === 'Esc' || e.key === 'Escape') {
        const openPopup = $('.popup-wrap.open');

        if (openPopup.length) {
          Areas.togglePopup(openPopup);
        }
      }
    });

    /**
     * Set favorites
     */
    this.favorites = new Favorites(this.settings.post_type, this.settings.limit_favorites);
    this.favorites.addEventListener('filtered', () => {
      this.hideNonFavoritedItemsInSwiper();

      if (!Array.from(this.favorites.els.filter[0].classList).includes('active')) {
        this.filterForm.trigger('submit');
      }
    });

    /**
     * Floor units carousel
     */
    this.swiper = new Swiper('.lots-overview.swiper', {
      slidesPerView: 1.2,
      modules: [Pagination, Navigation],
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      spaceBetween: 30,
      breakpoints: {
        768: {
          slidesPerView: 1.6,
        },
        1000: {
          slidesPerView: 3,
          centeredSlides: true,
        },
      },
    });

    this.swiper.on('paginationUpdate', (swiper, paginationEl) => {
      /* eslint-disable-next-line no-param-reassign */
      paginationEl.style.display = swiper.slidesGrid.length > 0 ? 'block' : 'none';
    });
  }

  static togglePopup(popupTarget) {
    const popup = popupTarget;

    if (!popup) {
      return;
    }

    popup.toggleClass('open');
  }

  handleFilter(e) {
    e.preventDefault();

    const filters = $(e.currentTarget).serializeObject();
    // const filterFavoritesBtn = this.favorites.els.filter[0];

    // if (Array.from(filterFavoritesBtn.classList).includes('active')) {
    //   filterFavoritesBtn.click();
    // }

    Areas.setFilteredClassOnMap(filters);
    this.filterAreas(filters);
    this.hideFilteredItemsInSwiper();
    this.floorSelector.setFoundAmount();
  }

  static setFilteredClassOnMap(filters) {
    const className = 'is-filtered';
    const map = document.querySelector('.lot-selector-map');
    const setFilters = Array.from(Object.values(filters)).filter(filter => filter[2] !== '*');

    map.classList.toggle(className, setFilters.length);
  }

  filterAreas(filters) {
    this.filterables.attr('data-filter-match', 'false');

    const filteredAreas = this.filterables.filter(function matchValues() {
      let match = true;

      Object.entries(filters).forEach((filter) => {
        const [name, filterObject] = filter;
        const type = filterObject[0];
        const operator = filterObject[1];
        const filterValue = filterObject[2];

        if (filterValue === '*') return;

        const filterName = name.replace('lot-selector-', '');
        const itemValue = $(this).data(filterName);

        if (
          typeof itemValue === 'undefined'
          || !Areas.filterEvaluation(itemValue, filterValue, operator, type)
        ) {
          match = false;
        }
      });

      return match;
    });

    filteredAreas.attr('data-filter-match', 'true');
  }

  hideFilteredItemsInSwiper() {
    const overviewItems = this.lotSelector.querySelectorAll('.swiper .overview-item');

    overviewItems.forEach((item) => {
      item.closest('.swiper-slide').classList.toggle('hidden', item.dataset.filterMatch === 'false');
    });

    this.swiper.update();
  }

  hideNonFavoritedItemsInSwiper() {
    const overviewItems = this.lotSelector.querySelectorAll('.swiper .overview-item');

    overviewItems.forEach((item) => {
      item.closest('.swiper-slide').classList.toggle('hidden', !Array.from(item.classList).includes('favorited') && Array.from(this.swiper.el.classList).includes('show-favorites'));
    });

    this.swiper.update();
  }

  static setPointClick() {
    if (window.matchMedia('(pointer: fine)').matches) {
      $('.lot-selector-area[data-href]').on('click', function navigateToLink() {
        const url = $(this).data('href');
        window.location = url;
      });
    }
  }

  static setPolyfills() {
    if (!SVGElement.prototype.contains) {
      SVGElement.prototype.contains = HTMLDivElement.prototype.contains;
    }
  }

  /**
   * Loop through each area and set their respective pop-ups
   */
  setPopups() {
    if ($(window).width() > 769) {
      if (this.areaSelector.length) {
        const defaultOptions = {
          appendTo: $('.lot-selector-map')[0],
          duration: 0,
          interactive: true,
          offset: [0, 10],
          placement: 'top',
          trigger: 'mouseenter click focus',
          zIndex: 9999,
        };

        // Merge default options with options passed by PHP
        const options = Object.assign({}, defaultOptions, this.settings.popup_options);

        this.areaSelector.each((index, area) => {
          const popupTarget = $(area).data('lot-popup-target');
          const popupEl = $(`.lot-selector-popups [data-lot-popup=${popupTarget}]`);

          // Set popup content
          [options.content] = popupEl;

          // Create popup
          const popup = new Tippy(area, options);

          // Add popup
          this.popups.push(popup);
        });
      }
    }
  }

  /**
   * Lets user zoom in/out and pan the lot selector view
   */
  setPanzoom() {
    if (!this.settings.enable_panzoom) {
      return;
    }

    const floors = this.lotSelector.querySelectorAll('.floor');
    const defaultOptions = {
      contain: 'outside',
    };

    // Merge default options with options passed by PHP
    const options = Object.assign({}, defaultOptions, this.settings.panzoom_options);

    // Set panzoom on every floor
    floors.forEach((floor) => {
      const panzoomEl = floor.querySelector('.lot-selector-panzoom');
      const zoomInButton = floor.querySelector('.zoom-in');
      const zoomOutButton = floor.querySelector('.zoom-out');

      const floorPanzoom = new Panzoom(panzoomEl, options);

      zoomInButton.addEventListener('click', () => floorPanzoom.zoomIn());
      zoomOutButton.addEventListener('click', () => floorPanzoom.zoomOut());

      // Rescale buttons on zoom
      panzoomEl.addEventListener('panzoomzoom', (e) => {
        panzoomEl.style.setProperty('--scale', e.detail.scale);
      });

      // Expose Panzoom on the floor
      /* eslint-disable no-param-reassign */
      floor.panzoom = floorPanzoom;
    });
  }

  static registrationTabs() {
    $('.tab_content_login').hide();
    $('ul.tabs_login li:first a').addClass('active').show();
    $('.tab_content_login:first').show();

    $('a[data-tab]').on('click', function setCurrentTab() {
      $('ul.tabs_login li a').removeClass('active');
      $(this).addClass('active');
      $('.tab_content_login').hide();
      const activeTab = $(this).data('tab');

      $(activeTab).show();
    });
  }

  /**
   * Eval passed values with operator
   * 
   * @param {*} itemValue 
   * @param {*} filterValue 
   * @param {*} operator 
   * @param {*} type Return value depends heavily on type, make sure this is the correct type
   * @returns Bool
   */
  static filterEvaluation(itemValue, filterValue, operator = '==', type = 'string') {
    /* eslint-disable no-new-func, no-param-reassign */
    itemValue = type === 'number' ? Areas.numberify(itemValue) : Areas.stringify(itemValue);

    if (operator === 'between' && filterValue.includes(',')) {
      filterValue = JSON.parse(filterValue);
    } else {
      filterValue = type === 'number' ? Areas.numberify(filterValue) : Areas.stringify(filterValue);
    }

    if (typeof filterValue === 'object') {
      filterValue.forEach((objectValue, index) => {
        filterValue[index] = type === 'number' ? Areas.numberify(objectValue) : Areas.stringify(objectValue);
      });
    }

    if (operator === 'between') {
      return itemValue > filterValue[0] && itemValue < filterValue[1];
    }

    return Function(`return (${itemValue} ${operator} ${filterValue})`)();
  }

  static stringify(value) {
    return `"${value}"`;
  }

  /**
   * Makes euro standard number (or price) JavaScript compatible
   * @param {*} value 
   * @returns 
   */
  static numberify(value) {
    let newValue = value;

    if (typeof value === 'string') {
      newValue = newValue.trim();

      // Remove all '.', and replace '.' for ','
      newValue = newValue.replace(/\./g, '').replace(',', '.');
    }

    return parseInt(newValue, 10);
  }

  handleHighlightButtonClick(e) {
    const button = e.currentTarget;
    const unitID = button.dataset.unit;

    this.highlightUnitOnMap(unitID);
  }

  handleHighlightAreaClick(e) {
    const area = e.currentTarget;
    const unitID = area.dataset.id;

    /* eslint-disable no-underscore-dangle */
    if (area._tippy) {
      area._tippy.hide();
    }
    /* eslint-enable no-underscore-dangle */

    this.highlightUnitInOverview(unitID);
  }

  highlightUnitOnMap(unitID) {
    const areas = this.lotSelector.querySelectorAll('.lot-selector-area');
    const area = this.lotSelector.querySelector(`.lot-selector-area[data-id="${unitID}"]`);
    const floor = area.closest('.floor');
    const floorLevel = floor.dataset.level;

    areas.forEach((singleArea) => {
      singleArea.classList.remove('highlight');
    });

    area.classList.add('highlight');

    this.floorSelector.setFloor(floorLevel);

    window.scrollTo({
      top: floor.getBoundingClientRect().top + window.scrollY - 200,
      behavior: 'smooth',
    });

    // Doesn't work, forget about it for now
    // An idea is to just highlight it with CSS instead of
    // trying to pan to it.

    // // Zoom in
    // floor.panzoom.zoom(2);

    // // Calculate new pan
    // const areaPoint = {
    //   clientX: 6,
    //   clientY: 50,
    // };

    // // First reset to 1
    // // Then zoomToPoint
    // floor.panzoom.zoom(1);
    // floor.panzoom.zoomToPoint(2, areaPoint);
  }

  highlightUnitInOverview(unitID) {
    let indexInOverview = 0;

    window.scrollTo({
      top: this.swiper.el.getBoundingClientRect().top + window.scrollY - 200,
      behavior: 'smooth',
    });

    /* eslint-disable-next-line arrow-body-style */
    indexInOverview = Array.from(this.swiper.slides).findIndex((slide) => {
      return slide.children[0].dataset.id === unitID;
    });

    this.swiper.slideTo(indexInOverview);
  }

  handleUnitTypeFilter(event) {
    const formData = new FormData(event.currentTarget);
    const typeFilter = formData.getAll('lot-selector-filter-unit_type');
    const type = typeFilter[2];

    if (type.includes('Opslagunit')) {
      this.floorSelector.setFloor('1');
    } else {
      this.floorSelector.setFloor('0');
    }
  }

  getUnits(event) {
    const formData = new FormData(event.currentTarget);
    const data = Areas.serialize(formData);

    // Set loading class
    this.lotSelector.classList.add('loading');

    const request = new Request(`${wpApiSettings.root}unit-selector/v1/get-units`, {
      method: 'POST',
      body: JSON.stringify({
        typeID: this.settings.ID,
        filters: data,
      }),
    });

    fetch(request)
      .then((response) => {
        // Server error, handle accordingly
        if (response.status === 500) {
          throw new Error('Server error retrieving units');
        }

        return response.json();
      })
      .then((response) => {
        // Something was wrong with the request
        if (response.error) {
          throw new Error(response.error);
        }

        this.filterables.forEach((filterable) => {
          filterable.dataset.filterMatch = response.includes(Number(filterable.dataset.postId));
        });
      })
      .then(() => {
        this.hideFilteredItemsInSwiper();
        this.floorSelector.setFoundAmount();
        this.handleUnitTypeFilter(event);
      })
      .catch((error) => {
        /* eslint-disable-next-line no-console */
        console.error(error);
      })
      .finally(() => {
        this.lotSelector.classList.remove('loading');
      });
  }

  getFilters(event = null) {
    let data = null;

    if (event) {
      const formData = new FormData(event.currentTarget);
      data = Areas.serialize(formData);
    }

    const request = new Request(`${wpApiSettings.root}unit-selector/v1/get-filters`, {
      method: 'POST',
      body: JSON.stringify({
        typeID: this.settings.ID,
        filters: data,
      }),
    });

    fetch(request)
      .then((response) => {
        // Server error, handle accordingly
        if (response.status === 500) {
          throw new Error('Server error retrieving filters');
        }

        return response.json();
      })
      .then((response) => {
        // Something was wrong with the request
        if (response.error) {
          throw new Error(response.error);
        }

        this.updateFilters(response);
      })
      .catch((error) => {
        /* eslint-disable-next-line no-console */
        console.error(error);
      });
  }

  updateFilters(filters) {
    const retrievedFilters = filters;
    const namePrefix = 'lot-selector-filter-';

    Array.from(retrievedFilters).forEach((retrievedFilter) => {
      const name = namePrefix + retrievedFilter.key;
      const filter = this.filterForm[0].querySelector(`select[name=${name}]`);
      
      retrievedFilter.options.forEach((retrievedOption) => {
        let { value } = retrievedOption;

        // Convert to queryable string
        if (typeof value === 'object') {
          value = `[${value.toString()}]`;
        }

        const option = filter.querySelector(`option[value="${value}"]`);
        option.text = `${retrievedOption.label} (${retrievedOption.count})`;
      });
    });
  }

  /**
   * Serialize form data
   * 
   * @param {*} data 
   * @returns 
   */
  static serialize(data) {
    const obj = {};
    
    /* eslint-disable-next-line no-restricted-syntax */
    for (const [key, value] of data) {
      if (obj[key] !== undefined) {
        if (!Array.isArray(obj[key])) {
          obj[key] = [obj[key]];
        }
        obj[key].push(value);
      } else {
        obj[key] = value;
      }
    }

    return obj;
  }
}

/**
 * Fire when everything is loaded
 */
$(document).ready(() => {
  new Areas().init();
});
